import { Avatar, Button, Icons, Stack, Text } from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';
import { PictureBookChapter } from '../interface';

interface ChapterProps {
  currentScreenData: PictureBookChapter;
  actionHandlers: {
    next: () => void;
    previous: () => void;
    close: () => void;
    exitModal: () => void;
  };
  currentScreenIndex?: number;
}

export const Chapter = ({
  currentScreenData,
  actionHandlers,
}: ChapterProps) => {
  const { isMobile } = useScreenSize();

  const handleClearModal = () => {
    actionHandlers.exitModal();
  };

  return (
    <Stack
      height={isMobile ? '100%' : '515px'}
      width="100%"
      flexDirection="row"
      sx={{ position: 'relative' }}
    >
      {!isMobile && (
        <Stack width="50%">
          <Avatar
            src={currentScreenData.image}
            sx={{ height: '100%', width: '100%' }}
            variant="square"
          />
        </Stack>
      )}
      <Stack
        width={isMobile ? '100%' : '50%'}
        height={isMobile ? '100%' : 'auto'}
        flexDirection="column"
        alignItems="center"
        p={{ xs: 2, md: 3 }}
      >
        <Icons.Clear
          sx={{
            width: '24px',
            height: '24px',
            alignSelf: 'flex-end',
            cursor: 'pointer',
          }}
          onClick={handleClearModal}
        />
        {isMobile && (
          <Avatar
            src={currentScreenData.image}
            sx={{ height: '155px', width: '155px' }}
            variant="square"
          />
        )}
        <Text sx={{ mb: 0.5 }}>CHAPTER</Text>
        <Avatar
          src={currentScreenData.chapterIcon}
          sx={{ height: '46px', width: '29px', mb: 3 }}
          variant="square"
        />
        <Text variant="h3">{currentScreenData.chapterTitle}</Text>
        <Text variant="body1" textAlign="center">
          {currentScreenData.chapterDescription}
        </Text>
        <Stack
          mt={isMobile ? 3.5 : 'auto'}
          flexDirection="row"
          width="100%"
          justifyContent="center"
        >
          {currentScreenData?.secondaryAction && (
            <Button
              variant="outlined"
              color="primary"
              onClick={
                actionHandlers[
                  currentScreenData.secondaryAction
                    .action as keyof typeof actionHandlers
                ]
              }
              sx={{ flex: isMobile ? 1 : null, mr: 2 }}
            >
              {currentScreenData.secondaryAction.text}
            </Button>
          )}
          {currentScreenData?.primaryAction && (
            <Button
              variant="contained"
              color="success"
              onClick={
                actionHandlers[
                  currentScreenData.primaryAction
                    .action as keyof typeof actionHandlers
                ]
              }
              sx={{ flex: isMobile ? 1 : null }}
            >
              {currentScreenData.primaryAction.text}
            </Button>
          )}
        </Stack>
      </Stack>
      {Boolean(currentScreenData.cornerIcon) && (
        <Avatar
          variant="square"
          src={currentScreenData.cornerIcon}
          sx={{ position: 'absolute', bottom: 0, right: 0 }}
        />
      )}
    </Stack>
  );
};
